import { CaseGranulometry } from '../../CaseGranulometry';

export const getCaseId = (caseGranulometry: CaseGranulometry) => caseGranulometry.id;
